import { CharacterStateBase } from './_stateLibrary';
import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import { CharacterAnimation } from '../../enums/CharacterAnimation';

export class PistolAimIdle extends CharacterStateBase implements ICharacterState {
    constructor(character: Character) {
        super(character);
        this.character.isAiming = true;
        this.character.simulation.velocitySimulator.damping = 0.6;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.simulation.setArcadeVelocityTarget(0);
        this.playAnimation(CharacterAnimation.PistolAimIdle, 0.2);
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.onDie();
    }
}
